import { render, staticRenderFns } from "./zxSqlOrFile.vue?vue&type=template&id=4d64896f&scoped=true&"
import script from "./zxSqlOrFile.vue?vue&type=script&lang=js&"
export * from "./zxSqlOrFile.vue?vue&type=script&lang=js&"
import style0 from "./zxSqlOrFile.vue?vue&type=style&index=0&id=4d64896f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d64896f",
  null
  
)

export default component.exports